import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface HealthBriefing {
  generatedAt: string;
  markdown: string;
  status: string;
}

export const briefingKeys = {
  latest: ['ai', 'briefing', 'latest'] as const,
};

/** Latest daily health briefing for the caller's tenant (null when none yet). */
export function useLatestBriefing() {
  return useQuery({
    queryKey: briefingKeys.latest,
    queryFn: async () => {
      const res = await api.get<{ briefing: HealthBriefing | null }>('/api/v2/ai/briefing/latest');
      return res.data.briefing;
    },
    staleTime: 1000 * 60 * 10,
    retry: false, // 404 when AI is disabled — don't hammer
  });
}

/** Regenerate the briefing on demand (uses the caller's own authority scope). */
export function useRefreshBriefing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await api.post<{ briefing: HealthBriefing }>('/api/v2/ai/briefing/refresh', {});
      return res.data.briefing;
    },
    onSuccess: (briefing) => queryClient.setQueryData(briefingKeys.latest, briefing),
  });
}
